var map = {
	"./1.png": 161,
	"./10.png": 162,
	"./11.png": 163,
	"./12.png": 164,
	"./13.png": 165,
	"./14.png": 166,
	"./2.png": 167,
	"./3.png": 168,
	"./4.png": 169,
	"./5.png": 170,
	"./6.png": 171,
	"./7.png": 172,
	"./8.png": 173,
	"./9.png": 174,
	"./aa.png": 175,
	"./accenture.png": 176,
	"./aitime.png": 177,
	"./alteryx.png": 178,
	"./ambest.png": 179,
	"./blueprism.png": 180,
	"./cme.png": 181,
	"./cognit.png": 182,
	"./darktrace.png": 183,
	"./dg.png": 184,
	"./difc.png": 185,
	"./eia.png": 186,
	"./fit.png": 187,
	"./infowatch.png": 188,
	"./microsoft.png": 189,
	"./mozn.png": 190,
	"./obg.png": 191,
	"./oracle.png": 192,
	"./paladion.png": 193,
	"./pwc.png": 194,
	"./reports.png": 195,
	"./sas.jpg": 196,
	"./telr.jpg": 197,
	"./visa.png": 198,
	"./watopedia.png": 199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;